/* UK postcode area to distribution network operator.
   Matched on the postcode AREA (the leading letters). Operator boundaries do
   not follow postcode boundaries, so areas genuinely split between two
   operators carry a `split` value and the tool declines to name one.

   `a`     = short licence area label, shown to the user
   `split` = the other operator's full name, for split areas only */
window.DNO_DATA = {
  operators: {
    NPG:  { name: "Northern Powergrid" },
    ENWL: { name: "Electricity North West" },
    SPEN: { name: "SP Energy Networks" },
    SSEN: { name: "SSEN Distribution" },
    NGED: { name: "National Grid Electricity Distribution" },
    UKPN: { name: "UK Power Networks" },
    NIE:  { name: "NIE Networks" }
  },
  areas: {
    // Northern Powergrid
    DH:{o:"NPG",a:"Northeast"},
    DL:{o:"NPG",a:"Northeast"},
    NE:{o:"NPG",a:"Northeast"},
    SR:{o:"NPG",a:"Northeast"},
    TS:{o:"NPG",a:"Northeast"},
    BD:{o:"NPG",a:"Yorkshire"},
    HD:{o:"NPG",a:"Yorkshire"},
    HG:{o:"NPG",a:"Yorkshire"},
    HU:{o:"NPG",a:"Yorkshire"},
    HX:{o:"NPG",a:"Yorkshire"},
    LS:{o:"NPG",a:"Yorkshire"},
    WF:{o:"NPG",a:"Yorkshire"},
    YO:{o:"NPG",a:"Yorkshire"},
    S:{o:"NPG",a:"Yorkshire",split:"National Grid Electricity Distribution (East Midlands area)"},
    DN:{o:"NPG",a:"Yorkshire",split:"National Grid Electricity Distribution (East Midlands area)"},

    // Electricity North West
    BB:{o:"ENWL",a:"North West"},
    BL:{o:"ENWL",a:"North West"},
    CA:{o:"ENWL",a:"North West"},
    FY:{o:"ENWL",a:"North West"},
    LA:{o:"ENWL",a:"North West"},
    M:{o:"ENWL",a:"North West"},
    OL:{o:"ENWL",a:"North West"},
    PR:{o:"ENWL",a:"North West"},
    WN:{o:"ENWL",a:"North West"},
    SK:{o:"ENWL",a:"North West",split:"SP Energy Networks (SP Manweb area)"},
    WA:{o:"ENWL",a:"North West",split:"SP Energy Networks (SP Manweb area)"},

    // SP Energy Networks
    CH:{o:"SPEN",a:"SP Manweb"},
    CW:{o:"SPEN",a:"SP Manweb"},
    L:{o:"SPEN",a:"SP Manweb"},
    LL:{o:"SPEN",a:"SP Manweb"},
    SY:{o:"SPEN",a:"SP Manweb",split:"National Grid Electricity Distribution (West Midlands area)"},
    G:{o:"SPEN",a:"SP Distribution"},
    EH:{o:"SPEN",a:"SP Distribution"},
    KA:{o:"SPEN",a:"SP Distribution"},
    ML:{o:"SPEN",a:"SP Distribution"},
    TD:{o:"SPEN",a:"SP Distribution"},
    DG:{o:"SPEN",a:"SP Distribution"},
    FK:{o:"SPEN",a:"SP Distribution"},
    KY:{o:"SPEN",a:"SP Distribution"},
    PA:{o:"SPEN",a:"SP Distribution",split:"SSEN Distribution (north of Scotland area)"},

    // SSEN Distribution
    AB:{o:"SSEN",a:"north of Scotland"},
    DD:{o:"SSEN",a:"north of Scotland"},
    HS:{o:"SSEN",a:"north of Scotland"},
    IV:{o:"SSEN",a:"north of Scotland"},
    KW:{o:"SSEN",a:"north of Scotland"},
    ZE:{o:"SSEN",a:"north of Scotland"},
    PH:{o:"SSEN",a:"north of Scotland",split:"SP Energy Networks (SP Distribution area)"},
    OX:{o:"SSEN",a:"southern England"},
    PO:{o:"SSEN",a:"southern England"},
    RG:{o:"SSEN",a:"southern England"},
    SL:{o:"SSEN",a:"southern England"},
    SO:{o:"SSEN",a:"southern England"},
    BH:{o:"SSEN",a:"southern England",split:"National Grid Electricity Distribution (South West area)"},
    SN:{o:"SSEN",a:"southern England",split:"National Grid Electricity Distribution (South West area)"},
    SP:{o:"SSEN",a:"southern England",split:"National Grid Electricity Distribution (South West area)"},
    HP:{o:"SSEN",a:"southern England",split:"UK Power Networks (Eastern area)"},
    MK:{o:"SSEN",a:"southern England",split:"UK Power Networks (Eastern area)"},
    GU:{o:"SSEN",a:"southern England",split:"UK Power Networks (South Eastern area)"},

    // National Grid Electricity Distribution
    DE:{o:"NGED",a:"East Midlands"},
    LE:{o:"NGED",a:"East Midlands"},
    LN:{o:"NGED",a:"East Midlands"},
    NG:{o:"NGED",a:"East Midlands"},
    NN:{o:"NGED",a:"East Midlands"},
    PE:{o:"NGED",a:"East Midlands",split:"UK Power Networks (Eastern area)"},
    B:{o:"NGED",a:"West Midlands"},
    CV:{o:"NGED",a:"West Midlands"},
    DY:{o:"NGED",a:"West Midlands"},
    HR:{o:"NGED",a:"West Midlands"},
    ST:{o:"NGED",a:"West Midlands"},
    TF:{o:"NGED",a:"West Midlands"},
    WR:{o:"NGED",a:"West Midlands"},
    WS:{o:"NGED",a:"West Midlands"},
    WV:{o:"NGED",a:"West Midlands"},
    CF:{o:"NGED",a:"South Wales"},
    NP:{o:"NGED",a:"South Wales"},
    SA:{o:"NGED",a:"South Wales"},
    LD:{o:"NGED",a:"South Wales"},
    BA:{o:"NGED",a:"South West"},
    BS:{o:"NGED",a:"South West"},
    EX:{o:"NGED",a:"South West"},
    PL:{o:"NGED",a:"South West"},
    TA:{o:"NGED",a:"South West"},
    TQ:{o:"NGED",a:"South West"},
    TR:{o:"NGED",a:"South West"},
    GL:{o:"NGED",a:"South West",split:"National Grid Electricity Distribution (West Midlands area)"},
    DT:{o:"NGED",a:"South West",split:"SSEN Distribution (southern England area)"},

    // UK Power Networks
    AL:{o:"UKPN",a:"Eastern"},
    CB:{o:"UKPN",a:"Eastern"},
    CM:{o:"UKPN",a:"Eastern"},
    CO:{o:"UKPN",a:"Eastern"},
    IP:{o:"UKPN",a:"Eastern"},
    LU:{o:"UKPN",a:"Eastern"},
    NR:{o:"UKPN",a:"Eastern"},
    SG:{o:"UKPN",a:"Eastern"},
    SS:{o:"UKPN",a:"Eastern"},
    E:{o:"UKPN",a:"London"},
    EC:{o:"UKPN",a:"London"},
    N:{o:"UKPN",a:"London"},
    NW:{o:"UKPN",a:"London"},
    SE:{o:"UKPN",a:"London"},
    SW:{o:"UKPN",a:"London"},
    W:{o:"UKPN",a:"London"},
    WC:{o:"UKPN",a:"London"},
    HA:{o:"UKPN",a:"London"},
    IG:{o:"UKPN",a:"London"},
    SM:{o:"UKPN",a:"London"},
    UB:{o:"UKPN",a:"London"},
    WD:{o:"UKPN",a:"London"},
    TW:{o:"UKPN",a:"London"},
    RM:{o:"UKPN",a:"London"},
    EN:{o:"UKPN",a:"London",split:"UK Power Networks (Eastern area)"},
    BN:{o:"UKPN",a:"South Eastern"},
    CT:{o:"UKPN",a:"South Eastern"},
    ME:{o:"UKPN",a:"South Eastern"},
    RH:{o:"UKPN",a:"South Eastern"},
    TN:{o:"UKPN",a:"South Eastern"},
    BR:{o:"UKPN",a:"London",split:"UK Power Networks (South Eastern area)"},
    CR:{o:"UKPN",a:"London",split:"UK Power Networks (South Eastern area)"},
    DA:{o:"UKPN",a:"London",split:"UK Power Networks (South Eastern area)"},
    KT:{o:"UKPN",a:"London",split:"UK Power Networks (South Eastern area)"},

    // Northern Ireland
    BT:{o:"NIE",a:"Northern Ireland",ni:true}
  }
};